export const learnArticles = [
  {
    slug: "community-college",
    number: "01",
    icon: "ri-file-list-3-line",
    category: "コミカレの始め方",
    title: "コミカレの始め方",
    lead: "コミュニティカレッジの基本から、エージェントを使わずに出願するまでの流れ、必要書類、メリットと注意点までをまとめました。",
    updatedAt: "2026.10.26",
    blocks: [
      {
        kind: "note",
        title: "このページについて",
        text: "制度の基本をまとめた無料記事です。学費・出願条件・必要書類は学校ごとに異なるため、必ず志望校の公式サイトで最終確認してください。",
      },
      {
        kind: "p",
        text: "この記事では留学準備の全体像を整理しています。学校選びの具体的な観点は「テキサス州のコミカレ選び」、出願に必要な英語力証明試験は「英語力証明試験」のページで詳しく解説しています（どちらも無料です）。",
      },
      { kind: "h", text: "コミュニティカレッジとは" },
      {
        kind: "p",
        text: "コミュニティカレッジ（コミカレ）は、主に2年制のカレッジで、修了すると準学士（Associate degree）などの資格が得られます。4年制大学の最初の2年分に近い一般教養や基礎科目が用意されていることが多く、アメリカ留学の入口として選ばれることがあります。",
      },
      {
        kind: "list",
        items: [
          "主に2年制で、州や地域が設置する公立校が中心",
          "準学士（Associate of Arts / Associate of Science / Associate of Applied Science など）が取得できる",
          "4年制大学への編入を見据えた一般教養の科目が用意されていることが多い",
          "留学生はF-1ビザ（学生ビザ）で通学する",
          "州によって制度・学費・入学条件が大きく異なる",
        ],
      },
      {
        kind: "p",
        text: "テキサス州には複数の公立コミュニティカレッジがあり、州内で共通のコア科目の枠組みが整えられています。ただし、実際にどの単位が編入先で認められるかは、編入先の大学が個別に判断します。",
      },
      { kind: "h", text: "出願までの基本的な流れ" },
      {
        kind: "list",
        items: [
          "学校選び：州・地域、専攻、学費、留学生の受け入れ状況、編入の実績などを公式サイトで確認する",
          "出願条件の確認：高校卒業（または同等）、英語力の基準、年齢などの条件を確認する",
          "書類の準備：成績証明書や英語スコア、財政証明などをそろえる",
          "オンライン出願：出願フォームを入力し、出願料を支払う",
          "合格後の手続き：入学手続きを行い、I-20の発行を受ける",
          "ビザ取得と渡米：F-1ビザを申請し、渡航時期を調整する",
        ],
      },
      { kind: "h", text: "必要書類の概要" },
      {
        kind: "list",
        items: [
          "パスポート（有効期限を確認）",
          "高校の成績証明書（英文の提出を求められることが多い）",
          "英語力の証明（TOEFL iBT、IELTS、Duolingo English Test など。基準は学校ごとに異なる）",
          "財政証明（学費と生活費を賄えることを示す銀行残高証明など）",
          "出願料",
          "学校によってはエッセイや推薦状、予防接種の記録",
        ],
      },
      {
        kind: "note",
        title: "書類は学校ごとに違います",
        text: "同じ州のコミカレでも、求める書類と形式は異なります。提出前に必ず入学予定校のチェックリストを確認してください。",
      },
      { kind: "h", text: "メリットとデメリット" },
      {
        kind: "table",
        head: ["メリット", "デメリット・注意点"],
        rows: [
          ["4年制大学と比べて学費が抑えられる場合がある", "編入が保証されているわけではない"],
          ["少人数のクラスが多く、基礎から学びやすい学校もある", "留学生向けのサポート体制は学校差が大きい"],
          ["編入を見据えて科目を計画的に選べる", "希望する専攻の科目が揃っていない場合がある"],
          ["出願手続きが比較的シンプルな学校が多い", "住まいや交通は自分で確保する必要がある"],
        ],
      },
      { kind: "h", text: "留学前に確認すべきこと" },
      {
        kind: "list",
        items: [
          "編入先の条件（必要GPA、単位数、専攻の前提科目）",
          "留学生の学費（international と州内学生で扱いが異なることが多い）",
          "入学時のテスト（テキサス州の公立校ではTSIA2などが案内される）",
          "住まい・健康保険・交通費",
          "為替と送金方法、学費の支払い時期",
          "出願締切とI-20の発行時期",
        ],
      },
      {
        kind: "pending",
        title: "運営者の出願記録（準備中）",
        text: "実際に使った書類、提出までの時系列、つまずいた点は、内容を確認できたものから順に追記します。現在は準備中です。",
      },
      {
        kind: "source",
        items: [
          {
            label: "Study in the States（米国国土安全保障省）",
            url: "https://studyinthestates.dhs.gov/students",
            checkedAt: "2026.10.26",
            terms: "政府公式サイト。閲覧は可能ですが、文章・画像の転載は行っていません。",
          },
          {
            label: "テキサス州高等教育委員会（THECB）",
            url: "https://www.highered.texas.gov/",
            checkedAt: "2026.10.26",
            terms: "州の公式サイト。制度の概要確認のみに使用し、本文は独自に作成しています。",
          },
        ],
      },
    ],
  },
  {
    slug: "f1-visa",
    number: "02",
    icon: "ri-passport-line",
    category: "F-1ビザ申請",
    title: "F-1ビザ申請",
    lead: "F-1ビザの基本、I-20・SEVIS・DS-160の役割、申請から面接までの流れ、必要書類と費用の考え方を整理しました。",
    updatedAt: "2026.10.26",
    blocks: [
      {
        kind: "note",
        title: "このページについて",
        text: "制度の基本をまとめた無料記事です。手数料や必要書類は変更されることがあるため、必ず公式サイトの最新情報を確認してください。",
      },
      { kind: "h", text: "F-1ビザの基本" },
      {
        kind: "p",
        text: "F-1ビザは、アメリカの学校で全日制の学術プログラムに通うための非移民ビザです。コミュニティカレッジも対象になります。ビザは学校が発行するのではなく、アメリカ大使館・領事館での面接などを経て発行されます。",
      },
      {
        kind: "list",
        items: [
          "学校からI-20（Form I-20）が発行されてから申請する",
          "原則として全日制（フルタイム）で学ぶ必要がある",
          "ビザの発行前に学業を始めることはできない（入国時期にもルールがある）",
          "ビザの有効期間と、アメリカに滞在できる期間は別の考え方",
        ],
      },
      { kind: "h", text: "I-20・SEVIS・DS-160の概要" },
      {
        kind: "table",
        head: ["用語", "概要"],
        rows: [
          ["I-20", "学校が発行する入学許可と学生情報の証明書。ビザ申請と入国の際に必要"],
          ["SEVIS", "留学生の情報を管理する米国政府のシステム。I-20の発行時に登録される"],
          ["I-901", "SEVISの手数料を支払うためのフォーム"],
          ["DS-160", "非移民ビザのオンライン申請書。面接時に確認ページが必要"],
          ["MRV", "ビザ申請手数料。金額はビザの種類などによって異なる"],
        ],
      },
      { kind: "h", text: "申請から面接までの流れ" },
      {
        kind: "list",
        items: [
          "学校に出願し、合格通知とI-20を受け取る",
          "I-20の記載内容（氏名、生年月日、プログラム期間、費用）を確認する",
          "I-901（SEVIS）手数料を支払い、支払い証明を保管する",
          "DS-160をオンラインで入力し、確認ページを印刷する",
          "ビザ申請料を支払い、面接を予約する",
          "必要書類を持って面接に臨む",
          "ビザ発行後、I-20のプログラム開始日を確認して渡航計画を立てる",
        ],
      },
      {
        kind: "note",
        title: "手数料と予約枠は変わります",
        text: "金額、支払い方法、面接の待ち時間は状況によって変わります。当サイトでは具体的な金額を掲載せず、公式サイトへのリンクのみを紹介しています。",
      },
      { kind: "h", text: "必要書類と費用の概要" },
      {
        kind: "list",
        items: [
          "パスポート",
          "I-20",
          "DS-160の確認ページ",
          "ビザ申請料の支払い記録",
          "I-901手数料の支払い証明",
          "規格に沿った証明写真",
          "財政証明（学費と生活費を賄えることを示す書類）",
          "学校の合格通知、成績証明書、英語スコア",
        ],
      },
      {
        kind: "p",
        text: "費用は主に、ビザ申請料、SEVIS（I-901）手数料、渡航費、そして入学前後に必要な学費・生活費です。エージェントを使わなくても、これらの費用は必ず発生します。",
      },
      {
        kind: "note",
        title: "追加書類を求められることがあります",
        text: "面接では、財政証明の内容や学習計画について質問されることがあります。学校の担当者や公式案内で事前に確認しておくと安心です。",
      },
      {
        kind: "pending",
        title: "面接の体験談（準備中）",
        text: "実際に聞かれた質問や準備の進め方は、内容を確認できた段階で追記します。現在は準備中です。",
      },
      {
        kind: "source",
        items: [
          {
            label: "U.S. Department of State — Student Visa",
            url: "https://travel.state.gov/content/travel/en/us-visas/study/student-visa.html",
            checkedAt: "2026.10.26",
            terms: "米国国務省の公式ページ。リンク紹介のみで、本文の転載は行っていません。",
          },
          {
            label: "Study in the States — Paying the I-901 SEVIS Fee",
            url: "https://studyinthestates.dhs.gov/students/prepare/paying-the-i-901-sevis-fee",
            checkedAt: "2026.10.26",
            terms: "政府公式ページ。手続きの概要確認のために参照しています。",
          },
          {
            label: "ICE — I-901 SEVIS Fee",
            url: "https://www.ice.gov/sevis/i901",
            checkedAt: "2026.10.26",
            terms: "政府公式ページ。最新の手数料はこちらで確認してください。",
          },
          {
            label: "在日米国大使館・領事館",
            url: "https://jp.usembassy.gov/",
            checkedAt: "2026.10.26",
            terms: "日本国内の面接手続きの公式案内。予約方法はこちらで確認してください。",
          },
        ],
      },
    ],
  },
  {
    slug: "tsi",
    number: "03",
    icon: "ri-draft-line",
    category: "TSI（TSIA2）対策",
    title: "TSI（TSIA2）対策",
    lead: "テキサス州の公立校で使われるTSIA2について、試験の位置づけ、分野、基準点の考え方、基準に届かなかった場合の対応をまとめました。",
    updatedAt: "2026.10.26",
    blocks: [
      {
        kind: "note",
        title: "TSIA2は「合否を決める入学試験」ではありません",
        text: "TSIA2は、大学レベルの授業に向けた準備ができているかを確認するためのプレイスメントテストです。点数によって、通常の授業を受けるか、補習的な支援を受けるかが決まります。入学の可否を直接決める試験ではありません。",
      },
      { kind: "h", text: "TSIとTSIA2の概要" },
      {
        kind: "p",
        text: "TSI（Texas Success Initiative）はテキサス州の制度で、そのための評価に使われるのがTSIA2（Texas Success Initiative Assessment 2.0）です。州内の公立カレッジ・大学で広く利用されています。",
      },
      {
        kind: "list",
        items: [
          "評価の分野はELAR（読解・文章作成）と数学の2つ",
          "主にコンピュータで受験する",
          "免除に該当する場合は受験が不要",
          "受験方法・料金・再受験のルールは学校ごとに案内される",
        ],
      },
      { kind: "h", text: "受験対象者と免除条件" },
      {
        kind: "list",
        items: [
          "テキサス州の公立カレッジ・大学に入学する学生は、原則としてTSIの要件を満たす必要がある",
          "一定のSAT・ACT等のスコア、過去に取得した大学単位、学位などによって免除される場合がある",
          "免除の条件は年度や学校によって変わる",
          "留学生の扱い（受験が必要か、いつ受けるか）は学校ごとに異なる",
        ],
      },
      {
        kind: "note",
        title: "必ず入学予定校の案内を確認してください",
        text: "免除条件や受験のタイミングは、学校の公式案内が最も正確です。当サイトでは個別の条件を断定していません。",
      },
      { kind: "h", text: "ELARと数学の試験内容" },
      {
        kind: "table",
        head: ["分野", "内容の概要"],
        rows: [
          ["ELAR", "読解と文章作成。選択式の問題に加えて、エッセイ（記述）が含まれる"],
          ["数学", "代数・数量推論・統計などの基礎的な内容。選択式の問題"],
        ],
      },
      {
        kind: "p",
        text: "出題範囲、問題数、制限時間は公式の案内で確認してください。当サイトでは公式の問題文や練習問題の転載は行いません。",
      },
      { kind: "h", text: "基準点の考え方" },
      {
        kind: "list",
        items: [
          "分野ごとに「college ready」と判断される基準が設定されている",
          "基準は州の枠組みに沿って各大学が設定し、公表している",
          "基準に届かない場合は、補習（developmental education）や並行履修などの支援につながる",
          "点数は入学の可否ではなく、授業の配置のために使われる",
        ],
      },
      { kind: "h", text: "基準点に届かなかった場合の対応" },
      {
        kind: "list",
        items: [
          "学校のアドバイザーに相談し、自分の位置づけを確認する",
          "補習コースや並行履修（corequisite）の仕組みを確認する",
          "再受験のルール（回数、待機期間、料金）を確認する",
          "苦手分野を整理してから、学習計画を立てて再受験する",
        ],
      },
      { kind: "h", text: "公式学習資料へのリンク" },
      {
        kind: "p",
        text: "公式の無料サンプル問題や学習リソースが公開されています。問題そのものを当サイトへ転載することはせず、リンクのみを紹介します。",
      },
      {
        kind: "pending",
        title: "運営者のTSIA2学習記録（準備中）",
        text: "実際の勉強方法やつまずいた分野は、内容を確認できた段階で追記します。現在は準備中です。",
      },
      {
        kind: "pending",
        title: "TSIA2対策・日本語解説ガイド（準備中）",
        text: "数学の重要分野の日本語解説やオリジナル練習問題をまとめた有料ガイドを準備しています。完成までは購入できません。",
      },
      {
        kind: "source",
        items: [
          {
            label: "College Board — Free TSIA2 PAA and Practice Resources",
            url: "https://accuplacer.collegeboard.org/students/free-tsia2-pre-assessment-and-practice-resources",
            checkedAt: "2026.10.26",
            terms: "公式の無料学習リソース。リンク紹介のみで、問題の転載・再配布は行いません。",
          },
          {
            label: "College Board — TSIA2 Additional Resources",
            url: "https://accuplacer.collegeboard.org/students/tsia2-additional-resources",
            checkedAt: "2026.10.26",
            terms: "公式の追加リソース。利用条件はリンク先の案内に従ってください。",
          },
          {
            label: "テキサス州高等教育委員会（THECB）— Texas Success Initiative",
            url: "https://www.highered.texas.gov/texas-success-initiative/",
            checkedAt: "2026.10.26",
            terms: "州の公式ページ。制度の概要確認のために参照しています。",
          },
        ],
      },
    ],
  },
  {
    slug: "transfer",
    number: "04",
    icon: "ri-line-chart-line",
    category: "4年制大学への編入",
    title: "4年制大学への編入",
    lead: "編入制度の仕組み、GPAと単位の考え方、準備の流れ、そして「保証されない」という前提までを整理しました。",
    updatedAt: "2026.10.26",
    blocks: [
      {
        kind: "note",
        title: "このページについて",
        text: "制度の基本をまとめた無料記事です。必要GPA・単位数・前提科目は大学と専攻によって異なります。必ず志望校の公式サイトで確認してください。",
      },
      { kind: "h", text: "編入制度の概要" },
      {
        kind: "p",
        text: "アメリカでは、コミュニティカレッジで一定の単位を取得したあと、4年制大学の2年次または3年次に編入（transfer）する進路があります。編入は自動的に決まるものではなく、改めて出願して審査を受ける必要があります。",
      },
      {
        kind: "list",
        items: [
          "「2+2」（コミカレ2年＋4年制大学2年）と呼ばれる進め方がある",
          "編入は transfer admission として、別の出願プロセスになる",
          "必要単位数やGPAの基準は大学・専攻ごとに異なる",
          "留学生は財政証明や語学力など、追加の書類を求められることがある",
        ],
      },
      { kind: "h", text: "GPAと単位の仕組み" },
      {
        kind: "list",
        items: [
          "単位はセメスター単位（credit hours）で数えられることが多い",
          "編入には一定の単位数が必要とされる（目安として60単位前後といわれることが多いが、大学ごとに異なる）",
          "GPA（成績平均）に最低ラインが設定されることが多い",
          "専攻によっては前提科目（prerequisites）の履修が必要",
          "取得した単位がすべて編入先の卒業要件に使えるとは限らない",
          "州内の共通コアに沿った科目は移行しやすい場合があるが、最終的な判断は編入先の大学",
        ],
      },
      {
        kind: "note",
        title: "単位数が足りていても足りないことがあります",
        text: "総単位数が基準を満たしていても、専攻の前提科目や特定分野の単位が不足していると、希望する学年・専攻に編入できない場合があります。",
      },
      { kind: "h", text: "編入準備の基本的な流れ" },
      {
        kind: "list",
        items: [
          "志望校と専攻を決め、編入条件を公式サイトで確認する",
          "1年目から、編入に必要な科目を逆算して履修計画を立てる",
          "GPAを維持する（再履修のルールも確認しておく）",
          "出願締切を確認し、エッセイ・推薦状・成績証明書などを準備する",
          "合格後に単位評価（transfer credit evaluation）を受け、認められる単位数を確認する",
          "住まい・費用・ビザ関連の書類を更新する",
        ],
      },
      { kind: "h", text: "編入時に注意すべきこと" },
      {
        kind: "list",
        items: [
          "コミカレから4年制大学への編入は保証されない",
          "州外・私立大学は条件も学費も大きく変わる",
          "締切が早い学校・専攻がある",
          "編入に伴い、I-20の移管やビザ関連の手続きが必要になる場合がある",
          "編入後に必要単位数が増え、卒業まで長くなる可能性もある",
        ],
      },
      { kind: "h", text: "編入先の大学によって条件が異なる" },
      {
        kind: "p",
        text: "同じ州内でも、編入の要件は大学ごとに異なります。州内の共通コアや編入の枠組みは参考になりますが、最終的な判断は各大学が行います。条件は年度ごとに見直されるため、出願年度の公式情報を確認してください。",
      },
      {
        kind: "pending",
        title: "運営者の編入準備の記録（準備中）",
        text: "現在、編入に向けて準備している段階です。履修計画や志望校選びの記録は、内容を確認できた段階で追記します。",
      },
      {
        kind: "source",
        items: [
          {
            label: "テキサス州高等教育委員会（THECB）",
            url: "https://www.highered.texas.gov/",
            checkedAt: "2026.10.26",
            terms: "州の公式サイト。制度の枠組みを確認するために参照しています。",
          },
          {
            label: "Study in the States（学生ビザ・学校移管の情報）",
            url: "https://studyinthestates.dhs.gov/students",
            checkedAt: "2026.10.26",
            terms: "政府公式サイト。ビザ関連の手続き確認に使用しています。",
          },
        ],
      },
    ],
  },
  {
    slug: "cost-life",
    number: "05",
    icon: "ri-home-5-line",
    category: "費用と学生生活",
    title: "費用と学生生活",
    lead: "留学費用の内訳と考え方、寮生活と授業の様子、現地での生活で気をつけたい点をまとめました。",
    updatedAt: "2026.10.26",
    blocks: [
      {
        kind: "note",
        title: "このページについて",
        text: "制度と一般的な考え方をまとめた無料記事です。具体的な金額は学校・地域・時期で大きく変わるため、当サイトでは金額を掲載していません。",
      },
      { kind: "h", text: "学費と生活費の基本情報" },
      {
        kind: "p",
        text: "留学費用は「学費」「住居」「食費」「保険」「交通費」「教科書・機材」「ビザ・渡航関連」に分けて考えると整理しやすくなります。留学生は州内学生より高い学費が設定されることが一般的です。",
      },
      {
        kind: "list",
        items: [
          "学費は学校・州・専攻によって大きく異なる",
          "住居は寮・アパート・ホームステイで費用が変わる",
          "健康保険は学校指定の加入が求められることが多い",
          "教科書や機材費は見落としやすい",
          "為替の変動で日本円の負担が変わる",
        ],
      },
      { kind: "h", text: "費用を抑えるための考え方" },
      {
        kind: "list",
        items: [
          "公立コミカレから編入するルートは、費用を抑える選択肢のひとつ（ただし必ず最も安い方法とは限らない）",
          "生活費の水準が異なる地域も比較する",
          "教科書は中古・レンタル・電子版も検討する",
          "食費は自炊を中心にすると抑えやすい",
          "奨学金や学内の仕事の条件は早めに確認する（留学生の就労には制限がある）",
        ],
      },
      {
        kind: "note",
        title: "エージェントを使わなくても費用はかかります",
        text: "学費、出願料、ビザ関連の費用、渡航費は必ず必要です。エージェントを使わないことは「費用ゼロ」を意味しません。",
      },
      { kind: "h", text: "寮生活と授業" },
      {
        kind: "list",
        items: [
          "寮がある学校と、自分でアパートを借りる学校がある",
          "授業は学期制（semester）で、シラバスに沿って進むことが多い",
          "出席・小テスト・課題・プレゼンなどで成績が決まることが多い",
          "オフィスアワーを活用すると質問しやすい",
        ],
      },
      { kind: "h", text: "現地の大学生活" },
      {
        kind: "list",
        items: [
          "授業時間より、授業外の勉強時間の確保が重要になる",
          "生活の英語と授業の英語は別物。専門用語は事前に準備する",
          "日本人が少ない環境では、自分から話す機会をつくる必要がある",
          "体調面・メンタル面のサポート窓口を入学時に確認しておく",
        ],
      },
      {
        kind: "pending",
        title: "運営者の実体験（準備中）",
        text: "実際の費用の内訳や生活の記録は、確認できた内容から順に追記します。現在は準備中です。",
      },
      {
        kind: "source",
        items: [
          {
            label: "Study in the States（留学生の生活・就労のルール）",
            url: "https://studyinthestates.dhs.gov/students",
            checkedAt: "2026.10.26",
            terms: "政府公式サイト。制度の確認に使用し、本文は独自に作成しています。",
          },
          {
            label: "テキサス州高等教育委員会（THECB）",
            url: "https://www.highered.texas.gov/",
            checkedAt: "2026.10.26",
            terms: "州の公式サイト。州内の高等教育の枠組み確認に使用しています。",
          },
        ],
      },
    ],
  },
];

export const learnIndexCards = [
  {
    slug: "community-college",
    number: "01",
    icon: "ri-file-list-3-line",
    title: "コミカレの始め方",
    description:
      "コミュニティカレッジの基本、出願までの流れ、必要書類、メリットと注意点をまとめています。",
  },
  {
    slug: "f1-visa",
    number: "02",
    icon: "ri-passport-line",
    title: "F-1ビザ申請",
    description:
      "I-20・SEVIS・DS-160の役割から、申請・面接の流れ、必要書類の考え方までを整理しています。",
  },
  {
    slug: "tsi",
    number: "03",
    icon: "ri-draft-line",
    title: "TSI（TSIA2）対策",
    description:
      "TSIA2の位置づけ、分野と基準点の考え方、基準に届かなかった場合の対応を解説しています。",
  },
  {
    slug: "transfer",
    number: "04",
    icon: "ri-line-chart-line",
    title: "4年制大学への編入",
    description:
      "編入の仕組み、GPAと単位の考え方、準備の流れと注意点をまとめています。",
  },
  {
    slug: "cost-life",
    number: "05",
    icon: "ri-home-5-line",
    title: "費用と学生生活",
    description:
      "費用の内訳と考え方、寮生活、授業、現地での生活で気をつけたい点を紹介します。",
  },
];